import React from 'react';
import { useAuth } from '../../contexts/authContext';
import { Navigate, useLocation } from 'react-router-dom';

const ProtectedRoute = ({ children, roles }) => {
    const { userLoggedIn, currentUser, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return <div className="flex justify-center items-center h-screen">Loading...</div>;
    }

    if (!userLoggedIn) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (roles && !roles.includes(currentUser.role)) {
        return <Navigate to="/home" replace />;
    }

    return children;
};

export default ProtectedRoute;
